export default __webpack_public_path__ + "static/media/jerusalem1.5deb35de.jpg";